import { createSlice } from "@reduxjs/toolkit";

export const modalSlice = createSlice({
  name: 'task',
  initialState: {
    open: false,
    modalContent: false,
    success: undefined,
  },
  reducers: {
    openModal: (state, action) => {
      document.body.classList.add('modal-open');
      state.open = true;
      state.success = undefined;
      state.modalContent = action.payload;
    },
    closeModal: (state, action) => {
      document.body.classList.remove('modal-open');
      state.open = false;
      state.modalContent = false;
      state.success = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { openModal, closeModal } = modalSlice.actions

//
export default modalSlice.reducer
